import React from "react";

const GlobeIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_138_1404"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_138_1404)">
        <path
          d="M9.99935 18.3337C8.84657 18.3337 7.76324 18.1149 6.74935 17.6774C5.73546 17.2399 4.85352 16.6462 4.10352 15.8962C3.35352 15.1462 2.75977 14.2642 2.32227 13.2503C1.88477 12.2364 1.66602 11.1531 1.66602 10.0003C1.66602 8.84755 1.88477 7.76421 2.32227 6.75033C2.75977 5.73644 3.35352 4.85449 4.10352 4.10449C4.85352 3.35449 5.73546 2.76074 6.74935 2.32324C7.76324 1.88574 8.84657 1.66699 9.99935 1.66699C11.1521 1.66699 12.2355 1.88574 13.2493 2.32324C14.2632 2.76074 15.1452 3.35449 15.8952 4.10449C16.6452 4.85449 17.2389 5.73644 17.6764 6.75033C18.1139 7.76421 18.3327 8.84755 18.3327 10.0003C18.3327 11.1531 18.1139 12.2364 17.6764 13.2503C17.2389 14.2642 16.6452 15.1462 15.8952 15.8962C15.1452 16.6462 14.2632 17.2399 13.2493 17.6774C12.2355 18.1149 11.1521 18.3337 9.99935 18.3337ZM9.99935 16.667C11.8605 16.667 13.4368 16.0212 14.7285 14.7295C16.0202 13.4378 16.666 11.8614 16.666 10.0003C16.666 9.9031 16.6625 9.80241 16.6556 9.69824C16.6487 9.59408 16.6452 9.50727 16.6452 9.43783C16.5757 9.8406 16.3882 10.1739 16.0827 10.4378C15.7771 10.7017 15.416 10.8337 14.9993 10.8337H13.3327C12.8743 10.8337 12.482 10.6705 12.1556 10.3441C11.8292 10.0177 11.666 9.62533 11.666 9.16699V8.33366H8.33268V6.66699C8.33268 6.20866 8.49588 5.8163 8.82227 5.48991C9.14865 5.16352 9.54102 5.00033 9.99935 5.00033H10.8327C10.8327 4.68088 10.9195 4.39963 11.0931 4.15658C11.2667 3.91352 11.4785 3.7156 11.7285 3.56283C11.4507 3.49338 11.1695 3.43783 10.8848 3.39616C10.6 3.35449 10.3049 3.33366 9.99935 3.33366C8.13824 3.33366 6.56185 3.97949 5.27018 5.27116C3.97852 6.56283 3.33268 8.13921 3.33268 10.0003H7.49935C8.41602 10.0003 9.20074 10.3267 9.85352 10.9795C10.5063 11.6323 10.8327 12.417 10.8327 13.3337V14.167H8.33268V16.4587C8.61046 16.5281 8.88477 16.5802 9.1556 16.6149C9.42643 16.6496 9.70768 16.667 9.99935 16.667Z"
          fill="#505050"
        />
      </g>
    </svg>
  );
};

export default GlobeIcon;
